<script>
     export let angebot; 
</script>

<style>
 .tags a {
		/* float: left; */
		display: flex;
		position: relative;
		width: 3em;
		text-align: center;
		height: 2em;
		margin-left: 20px;
		padding: 0 12px;
		line-height: 2em;
		background: #1f8dd6;
		color: #fff;
		font-size: 0.6em;
		font-weight: 600;
		text-decoration: none;		
	}

	.tags a:before {
		content: "";
		position: absolute;
		top: 0;		
		width: 0;
		height: 0;		
		border-style: solid;		
	}
	
	.tags a:after {
		content: "";
		position: absolute;
		top: 0.75em;
        left:-0.5em;
		width: 0.5em;
		height: 0.5em;
		-moz-border-radius: 2px;
		-webkit-border-radius: 2px;
		border-radius: 1em;
		background: #fff;
		-moz-box-shadow: -1px -1px 2px #004977;
		-webkit-box-shadow: -1px -1px 2px #004977;
		box-shadow: -1px -1px 2px #004977;
	}	
	
	.tags a:hover {
		background: #1d85ca;
	}	
	
	/* Add rounded corners to right end of the anchor tag */
	.price-tag a {		
		-moz-border-radius-bottomright: 4px;
		-webkit-border-bottom-right-radius: 4px;
		border-bottom-right-radius: 4px;
		-moz-border-radius-topright: 4px;
		-webkit-border-top-right-radius: 4px;
		border-top-right-radius: 4px;
background-color: #1f8dd6;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23d1e0eb' fill-opacity='0.4' fill-rule='evenodd'%3E%3Ccircle cx='3' cy='3' r='2'/%3E%3Ccircle cx='5' cy='5' r='2'/%3E%3C/g%3E%3C/svg%3E");  
float:right;	
}
	
	/* Position and show only right border of triangle  */
	.price-tag a:before {		
		left: -1em;	
		border-color: transparent #1f8dd6 transparent transparent;
		border-width: 1em 1em 1em 0;
    
	}
	

	
	.price-tag a:hover:before {
		border-color: transparent #1d85ca transparent transparent;
	}


</style>

<div class="tags">
    <!-- svelte-ignore a11y-invalid-attribute -->
    <div class="price-tag"><a href="https://boardgamegeek.com/market/product/{angebot.productid}" target=_blank>{angebot.price} €</a></div>
</div>
